export default "__VITE_ASSET__e79a365c__"